import PingFangRegularText from './PingFangRegularText';

export default PingFangRegularText;
